const Docs = () => {
  window.location = "https://apoxy.dev/docs";
}

export default Docs;
